import React from 'react';
import { PREMIUM_SIZES, PERGOLA_HEIGHT } from '../../utils/pergolaCatalog';

const PergolasProductShowcase: React.FC = () => {
  const price = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: 0 }).format(PREMIUM_SIZES[0].priceCAD);
  return <section className="py-20 bg-gray-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-primary mb-4">Choose Your Pergola</h2>
        <p className="text-xl text-gray-600">Premium comfort, with a proposal to fit your project.</p>
      </div>
      <div className="grid lg:grid-cols-2 gap-10">
        <article className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col">
          <img src="/images/pergolas/pic1.webp" alt="Motorized aluminum pergola" className="w-full h-64 object-cover" loading="lazy" />
          <div className="p-8 flex flex-col flex-1">
            <h3 className="text-2xl font-bold text-primary mb-3">Premium</h3>
            <p className="text-3xl font-bold text-accent mb-2">From {price} CAD</p>
            <p className="text-gray-600 mb-5">3×3 m footprint (approx. 10×10 ft), before tax. Standard installation and delivery included.</p>
            <ul className="space-y-3 text-gray-700 mb-6">
              <li>Motorized double-layer louvers</li><li>White perimeter lighting included</li>
              <li>Aluminum frame with integrated drainage</li><li>White or dark grey finish</li>
              <li>Height: {PERGOLA_HEIGHT}</li>
              <li>Optional privacy screens priced by the selected sides</li>
            </ul>
            <p className="text-sm text-gray-600 mb-6">Special site work, such as footings or deck reinforcement, is quoted separately.</p>
            <a className="mt-auto block bg-accent text-white rounded-lg px-6 py-3 text-center font-semibold" href="/pergola-quote">Get an instant estimate</a>
          </div>
        </article>
        <article className="bg-white rounded-xl shadow-lg overflow-hidden border-2 border-accent flex flex-col">
          <div className="bg-primary text-white p-12 min-h-64 flex items-center justify-center"><span className="text-5xl font-bold">Premium+</span></div>
          <div className="p-8 flex flex-col flex-1">
            <h3 className="text-2xl font-bold text-primary mb-3">Premium+</h3>
            <p className="text-3xl font-bold text-accent mb-4">Individual quote</p>
            <p className="text-gray-600 mb-6">Discuss your requirements with our team. We will prepare a proposal with the configuration, specifications and price for your project.</p>
            <p className="text-gray-600 mb-8">Pricing, options and site requirements are confirmed through a personal consultation.</p>
            <a className="mt-auto block bg-accent text-white rounded-lg px-6 py-3 text-center font-semibold" href="/pergola-quote?model=premium-plus">Request a Premium+ quote</a>
          </div>
        </article>
      </div>
    </div>
  </section>;
};
export default PergolasProductShowcase;
